<template>
  <!--
    Universal / App Link hedefi: https://fantaslink.com/app/...
    Cihazda uygulama yüklüyse bu sayfa hiç görünmez (işletim sistemi doğrudan uygulamayı açar).
    Yüklü değilse buraya düşülür; kullanıcıya uygulamayı açma / mağaza seçenekleri sunulur.
  -->
  <v-container class="py-10" style="max-width: 560px">
    <v-card class="pa-6 text-center">
      <v-icon size="56" color="primary">mdi-cellphone-arrow-down</v-icon>
      <h2 class="mt-4 mb-2">Fantaslink uygulamasında aç</h2>
      <p class="grey--text text--darken-1 mb-6">
        Kampanya detayını görmek için Fantaslink mobil uygulamasını kullan. Uygulama yüklüyse
        aşağıdaki butona dokunman yeterli.
      </p>

      <v-btn color="primary" large block @click="openApp">Uygulamada aç</v-btn>

      <div class="mt-6">
        <a :href="appStoreUrl" target="_blank" rel="noopener" class="mr-4">App Store</a>
        <a :href="playStoreUrl" target="_blank" rel="noopener">Google Play</a>
      </div>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AppLinkFallback extends Vue {
  appStoreUrl = "https://apps.apple.com/tr/app/fantaslink/id6499074739";
  playStoreUrl = "https://play.google.com/store/apps/details?id=com.fantaslink";

  // /app/campaign/<id> → fantaslink://campaign/<id>
  get schemeUrl(): string {
    const path = this.$route.path.replace(/^\/app\/?/, "");
    return `fantaslink://${path}`;
  }

  mounted() {
    this.openApp();
  }

  openApp() {
    window.location.href = this.schemeUrl;
  }
}
</script>
